/** True when the range covers exactly one day. */
export function isSingleDay(range: [string, string] | null): boolean {
  return !!range && range[0] === range[1];
}

/** Adds whole days to a `YYYY-MM-DD` string, returning the same format. */
export function addCalendarDays(date: string, days: number): string {
  const parsed = new Date(`${date}T00:00:00`);
  parsed.setDate(parsed.getDate() + days);
  return toDateString(parsed);
}

/** Formats a Date as `YYYY-MM-DD` in local time (never UTC-shifted). */
export function toDateString(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}
